module.exports = __webpack_public_path__ + "static/media/lod-s.28aba802.svg";